import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss']
})
export class DeleteAccountComponent implements OnInit {
  year: number;

  constructor(private titleService: Title) {}

  ngOnInit() {
    this.year = new Date().getFullYear();
    this.titleService.setTitle('Delete Your DarkCarz Account');
  }
}
